import { Menu as AntMenu } from 'antd'
import type { ComponentProps } from 'react'

type AntMenuProps = ComponentProps<typeof AntMenu>

export interface AppMenuProps extends AntMenuProps {}

export const AppMenu = (props: AppMenuProps) => <AntMenu {...props} />

export const AppMenuItem = AntMenu.Item
export const AppSubMenu = AntMenu.SubMenu
export const AppMenuItemGroup = AntMenu.ItemGroup
export const AppMenuDivider = AntMenu.Divider
